import SecondaryMedium from "./SecondaryMedium";

export default SecondaryMedium;
export { SecondaryMedium as H5 };
